import { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Context from '@gisatcz/cross-package-react-context';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MIN_OVERLAY_WIDTH = 5; //in pixels

var OverlayItem = function OverlayItem(_ref) {
  var overlay = _ref.overlay,
      getX = _ref.getX,
      vertical = _ref.vertical,
      onClick = _ref.onClick;
  var defaultHoverContext = 'TimeLineContext';
  var HoverContext = Context.getContext(defaultHoverContext);
  var context = useContext(HoverContext);
  var start = getX(overlay.start);
  var end = getX(overlay.end);
  var label = null;
  var MIN_WIDTH_MODE = end - start > MIN_OVERLAY_WIDTH ? false : true;
  var diff = MIN_WIDTH_MODE ? MIN_OVERLAY_WIDTH : end - start;
  var x = vertical ? overlay.top : MIN_WIDTH_MODE ? start - diff / 2 : start;
  var yL = vertical ? start : overlay.top + overlay.height - 2;
  var yR = vertical ? start : overlay.top;
  var eHeight = vertical ? diff : overlay.height;
  var width = vertical ? overlay.height : diff;

  var onOverlayClick = function onOverlayClick() {
    if (typeof onClick === 'function') {
      onClick(overlay);
    }
  };

  var onMouseEnter = function onMouseEnter(evt) {
    context.onHover({
      x: evt.pageX,
      y: evt.pageY
    }, [{
      key: overlay.key,
      overlay: overlay
    }]);
  };

  var onMouseLeave = function onMouseLeave() {
    context.onHoverOut([{
      key: overlay.key,
      overlay: overlay
    }]);
  }; //TODO - solve label in vertical


  if (!overlay.hideLabel && overlay.label && !vertical) {
    label = /*#__PURE__*/_jsx("text", {
      x: x,
      y: yL,
      className: "ptr-timeline-overlay-label",
      children: overlay.label
    });
  }

  return /*#__PURE__*/_jsxs("g", {
    className: classNames('ptr-timeline-overlay', overlay.classes),
    onClick: onOverlayClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: [/*#__PURE__*/_jsx("rect", {
      x: x,
      width: width,
      y: yR,
      rx: eHeight / 2,
      ry: eHeight / 2,
      height: eHeight,
      fill: overlay.backgound
    }), label]
  }, "".concat(overlay.key));
};

OverlayItem.propTypes = {
  getX: PropTypes.func,
  overlay: PropTypes.object,
  vertical: PropTypes.bool,
  onClick: PropTypes.func
};
OverlayItem.defaultProps = {
  getX: function getX() {},
  overlay: {},
  vertical: false,
  onClick: function onClick() {}
};
export default OverlayItem;